import { render, staticRenderFns } from "./ReminderHome.vue?vue&type=template&id=38768836"
import script from "./ReminderHome.vue?vue&type=script&lang=js"
export * from "./ReminderHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports